<ng-content *ngIf="(isSecure$ | async) === true"></ng-content>
